export const UPDATE_PROMO_ONBOARD_DISMISS = "UPDATE_PROMO_ONBOARD_DISMISS";
